import Vue from 'vue';
import Router from 'vue-router';
import RouterView from './components/RouterView.vue';
import Index from './pages/Index.vue';
import Inge from './pages/Inge.vue';
import Julia from './pages/Julia.vue';
import Ralf from './pages/Ralf.vue';
import Alevtina from './pages/Alevtina.vue';
import Request from './pages/Request.vue';
import RequestSuccess from './pages/RequestSuccess.vue';
import LegalInfo from './pages/LegalInfo.vue';
import Terms from './pages/Terms.vue';
import Contact from './pages/Contact.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import { Trans } from './plugins/translation';
Vue.use(Router);
const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/:lang',
            component: RouterView,
            children: [
                {
                    path: '',
                    name: 'index',
                    components: { default: Index, header: MainNavbar, footer: MainFooter },
                    props: {
                        header: { colorOnScroll: 400, title: 'index.title', description: 'index.description', img: '/img/home/background/bg_home_01.jpg' },
                        footer: { backgroundColor: 'black' }
                    }
                },
                {
                    path: 'villa-inge',
                    name: 'villa-inge',
                    components: { default: Inge, header: MainNavbar, footer: MainFooter },
                    props: {
                        header: { colorOnScroll: 100, title: 'inge.title', description: 'inge.description', img: '/img/inge/background/bg_inge_1.jpg', requestVilla: 'inge' },
                        footer: { backgroundColor: 'black' }
                    }
                },
                {
                    path: 'finca-julia',
                    name: 'finca-julia',
                    components: { default: Julia, header: MainNavbar, footer: MainFooter },
                    props: {
                        header: { colorOnScroll: 100, title: 'julia.title', description: 'julia.description', img: '/img/julia/background/bg_julia_1.jpg', requestVilla: 'julia' },
                        footer: { backgroundColor: 'black' }
                    }
                },
                {
                    path: 'villa-de-alevtina',
                    name: 'villa-de-alevtina',
                    components: { default: Alevtina, header: MainNavbar, footer: MainFooter },
                    props: {
                        header: { colorOnScroll: 100, title: 'alevtina.title', description: 'alevtina.description', img: '/img/alevtina/background/alevtina_01.jpg', requestVilla: 'alevtina' },
                        footer: { backgroundColor: 'black' }
                    }
                },
                {
                    path: 'villa-ralf',
                    name: 'villa-ralf',
                    components: { default: Ralf, header: MainNavbar, footer: MainFooter },
                    props: {
                        header: { colorOnScroll: 100, title: 'ralf.title', description: 'ralf.description', img: '/img/ralf/background/ralf_01.jpg', requestVilla: 'ralf' },
                        footer: { backgroundColor: 'black' }
                    }
                },
                {
                    path: 'request',
                    name: 'request',
                    components: { default: Request, header: MainNavbar, footer: MainFooter },
                    props: {
                        default: (route) => ({ requestVilla: route.params.villa }),
                        header: { title: 'request.title', small: true },
                        footer: { backgroundColor: 'black' }
                    }
                },
                {
                    path: 'request-success',
                    name: 'request-success',
                    components: { default: RequestSuccess, header: MainNavbar, footer: MainFooter },
                    props: {
                        header: { title: 'request-success.title', small: true },
                        footer: { backgroundColor: 'black' }
                    }
                },
                {
                    path: 'legal-info',
                    name: 'legal-info',
                    components: { default: LegalInfo, header: MainNavbar, footer: MainFooter },
                    props: {
                        header: { title: 'legal-info.title', small: true },
                        footer: { backgroundColor: 'black' }
                    }
                },
                {
                    path: 'terms',
                    name: 'terms',
                    components: { default: Terms, header: MainNavbar, footer: MainFooter },
                    props: {
                        header: { title: 'terms.title', small: true },
                        footer: { backgroundColor: 'black' }
                    }
                },
                {
                    path: 'contact',
                    name: 'contact',
                    components: { default: Contact, header: MainNavbar, footer: MainFooter },
                    props: {
                        header: { title: 'contact.title', small: true },
                        footer: { backgroundColor: 'black' }
                    }
                }
            ]
        },
        {
            // Redirect user to supported lang version.
            path: '*',
            redirect(to) {
                return '/' + Trans.getUserSupportedLang() + '/';
            }
        }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        }
        else {
            return { x: 0, y: 0 };
        }
    }
});
router.beforeEach(Trans.routeMiddleware);
export default router;
